import { render } from "./SignDocument.vue?vue&type=template&id=c7764452"
import script from "./SignDocument.vue?vue&type=script&lang=js"
export * from "./SignDocument.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__